/* ============================================================
   MÉTIS WINGS — FREE GIFT ENGINE
   Auto-adds the $0.00 Sticker Pack + Wrist Keychain whenever the
   cart holds at least one qualifying item, and removes them when
   it doesn't. Gifts are pinned to qty 1 and cannot be edited.
   Config comes from snippets/mw-gift-engine.liquid.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.MW_GIFTS;
  if (!CFG || !CFG.gifts || !CFG.gifts.length) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT_PRODUCT_IDS = CFG.gifts.map(function (g) { return g.productId; });
  var GIFT_PROP = '_free_gift';

  var internal = false;   // true while the engine itself is talking to /cart
  var running = false;    // reconcile in flight
  var queued = false;     // another reconcile requested mid-flight
  var lastCart = null;

  /* ---------- helpers ---------- */

  function isGift(item) { return GIFT_PRODUCT_IDS.indexOf(item.product_id) !== -1; }
  function isExcluded(item) { return CFG.excludedProductIds.indexOf(item.product_id) !== -1; }
  function qualifies(item) { return !isGift(item) && !isExcluded(item); }

  function giftConfigFor(productId) {
    for (var i = 0; i < CFG.gifts.length; i++) {
      if (CFG.gifts[i].productId === productId) return CFG.gifts[i];
    }
    return null;
  }

  function post(url, body) {
    internal = true;
    return fetch(ROOT.replace(/\/$/, '') + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .catch(function (e) { console.warn('[MW Gifts]', e); return null; })
      .then(function (r) { internal = false; return r; });
  }

  function getCart() {
    internal = true;
    return fetch(ROOT.replace(/\/$/, '') + '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; })
      .then(function (c) { internal = false; return c; });
  }

  function changeByKey(key, quantity) {
    return post('/cart/change.js', { id: key, quantity: quantity });
  }

  function addGift(variantId) {
    var props = {};
    props[GIFT_PROP] = 'yes';
    return post('/cart/add.js', { items: [{ id: variantId, quantity: 1, properties: props }] });
  }

  /* ---------- cart reconciliation ---------- */

  function reconcile() {
    if (running) { queued = true; return Promise.resolve(); }
    running = true;

    return getCart()
      .then(function (cart) {
        if (!cart) return null;
        lastCart = cart;

        var qualifyingCount = 0;
        var giftLines = {};

        cart.items.forEach(function (item) {
          if (isGift(item)) {
            // Only ever keep the first line of each gift product.
            if (giftLines[item.product_id]) {
              giftLines[item.product_id].dupes.push(item);
            } else {
              giftLines[item.product_id] = { item: item, dupes: [] };
            }
          } else if (qualifies(item)) {
            qualifyingCount += item.quantity;
          }
        });

        var steps = [];

        if (qualifyingCount > 0) {
          CFG.gifts.forEach(function (gift) {
            var present = giftLines[gift.productId];
            if (!present) {
              steps.push(function () { return addGift(gift.variants[0].id); });
            } else {
              present.dupes.forEach(function (d) {
                steps.push(function () { return changeByKey(d.key, 0); });
              });
              if (present.item.quantity !== 1) {
                steps.push(function () { return changeByKey(present.item.key, 1); });
              }
            }
          });
        } else {
          Object.keys(giftLines).forEach(function (pid) {
            var g = giftLines[pid];
            steps.push(function () { return changeByKey(g.item.key, 0); });
            g.dupes.forEach(function (d) {
              steps.push(function () { return changeByKey(d.key, 0); });
            });
          });
        }

        if (!steps.length) return cart;

        return steps
          .reduce(function (chain, step) { return chain.then(step); }, Promise.resolve())
          .then(getCart)
          .then(function (updated) {
            if (updated) lastCart = updated;
            return refreshCartUI().then(function () { return updated; });
          });
      })
      .then(function (result) {
        running = false;
        render();
        if (queued) { queued = false; return reconcile(); }
        return result;
      })
      .catch(function (e) {
        running = false;
        console.warn('[MW Gifts]', e);
      });
  }

  /* ---------- swap a gift variant (colour picker) ---------- */

  function swapGiftVariant(productId, variantId) {
    if (!lastCart) return;
    var current = null;
    lastCart.items.forEach(function (item) {
      if (item.product_id === productId && !current) current = item;
    });
    if (current && current.variant_id === variantId) return;

    var chain = Promise.resolve();
    if (current) chain = chain.then(function () { return changeByKey(current.key, 0); });
    chain
      .then(function () { return addGift(variantId); })
      .then(getCart)
      .then(function (c) { if (c) lastCart = c; })
      .then(refreshCartUI)
      .then(render);
  }

  /* ---------- re-render the theme's cart UI ---------- */

  function innerFrom(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshCartUI() {
    var drawer = document.querySelector('cart-drawer');
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var bubble = document.getElementById('cart-icon-bubble');

    var ids = [];
    if (drawer) ids.push('cart-drawer');
    if (itemsEl && itemsEl.dataset.id) ids.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) ids.push(footerEl.dataset.id);
    if (bubble) ids.push('cart-icon-bubble');
    if (!ids.length) return Promise.resolve();

    var url = window.location.pathname + '?sections=' + ids.join(',');

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (drawer && data['cart-drawer']) {
          var target = document.getElementById('CartDrawer');
          var html = innerFrom(data['cart-drawer'], '#CartDrawer');
          if (target && html !== null) target.innerHTML = html;
          var inner = drawer.querySelector('.drawer__inner');
          if (inner && lastCart && lastCart.item_count > 0) inner.classList.remove('is-empty');
        }
        if (itemsEl && itemsEl.dataset.id && data[itemsEl.dataset.id]) {
          var src = innerFrom(data[itemsEl.dataset.id], '.js-contents');
          var dst = itemsEl.querySelector('.js-contents');
          if (src !== null && dst) dst.innerHTML = src;
        }
        if (footerEl && footerEl.dataset.id && data[footerEl.dataset.id]) {
          var fsrc = innerFrom(data[footerEl.dataset.id], '.js-contents');
          var fdst = footerEl.querySelector('.js-contents');
          if (fsrc !== null && fdst) fdst.innerHTML = fsrc;
        }
        if (bubble && data['cart-icon-bubble']) {
          var bhtml = innerFrom(data['cart-icon-bubble'], '.shopify-section');
          if (bhtml !== null) bubble.innerHTML = bhtml;
        }
      })
      .catch(function (e) { console.warn('[MW Gifts] refresh', e); })
      .then(function () { markGiftLineItems(); });
  }

  /* ---------- lock down gift line items in the cart UI ---------- */

  function markGiftLineItems() {
    if (!lastCart) return;
    var giftKeys = lastCart.items.filter(isGift).map(function (i) { return i.key; });
    if (!giftKeys.length) return;

    giftKeys.forEach(function (key) {
      var rows = document.querySelectorAll('[id*="' + CSS.escape(key) + '"]');
      rows.forEach(function (row) {
        var container = row.closest('tr, .cart-item, li');
        if (!container || container.classList.contains('mw-gift-line')) return;
        container.classList.add('mw-gift-line');
      });
    });

    // Fallback: match by product title when the theme doesn't expose the key.
    CFG.gifts.forEach(function (gift) {
      document.querySelectorAll('.cart-item__name').forEach(function (nameEl) {
        if (nameEl.textContent.trim().indexOf(gift.title) === 0 ||
            nameEl.textContent.indexOf('(Free Gift)') !== -1) {
          var container = nameEl.closest('tr, .cart-item, li');
          if (container) container.classList.add('mw-gift-line');
        }
      });
    });
  }

  /* ---------- visual module ---------- */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function giftIcon() {
    return '<svg class="mw-gifts__icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M20 12v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M3 8h18v4H3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="M12 8v13" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M12 8S9.5 8 8.2 6.9C7.2 6 7.3 4.4 8.4 3.7c1-.6 2.2-.2 2.9.8L12 8zM12 8s2.5 0 3.8-1.1c1-.9.9-2.5-.2-3.2-1-.6-2.2-.2-2.9.8L12 8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
      '</svg>';
  }

  function checkIcon() {
    return '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true">' +
      '<path d="M4.5 10.5l3.5 3.5 7.5-8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function activeVariantFor(productId) {
    if (!lastCart) return null;
    for (var i = 0; i < lastCart.items.length; i++) {
      if (lastCart.items[i].product_id === productId) return lastCart.items[i].variant_id;
    }
    return null;
  }

  function giftRow(gift, state) {
    var html = '<li class="mw-gift">';
    html += '<div class="mw-gift__media"><img src="' + esc(gift.image) + '" alt="' + esc(gift.title) + '" loading="lazy" width="56" height="56"></div>';
    html += '<div class="mw-gift__body">';
    html += '<span class="mw-gift__title">' + esc(gift.title) + '</span>';

    if (gift.swatches && state === 'active') {
      var active = activeVariantFor(gift.productId);
      html += '<div class="mw-gift__swatches" role="group" aria-label="Keychain colour">';
      gift.variants.forEach(function (v) {
        var color = (CFG.swatchColors && CFG.swatchColors[v.name]) || '#888';
        html += '<button type="button" class="mw-swatch' + (v.id === active ? ' is-active' : '') + '"' +
          ' data-mw-swatch data-mw-product="' + gift.productId + '" data-mw-variant="' + v.id + '"' +
          ' style="--mw-swatch:' + color + '" title="' + esc(v.name) + '" aria-label="' + esc(v.name) + '"' +
          ' aria-pressed="' + (v.id === active ? 'true' : 'false') + '"></button>';
      });
      html += '</div>';
    } else {
      html += '<span class="mw-gift__meta">' + esc(gift.meta) + '</span>';
    }

    html += '</div>';
    html += '<div class="mw-gift__price"><s>' + esc(gift.compareAt) + '</s><b>' + esc(CFG.text.free) + '</b></div>';
    html += '</li>';
    return html;
  }

  function render() {
    var nodes = document.querySelectorAll('[data-mw-gifts]');
    if (!nodes.length) return;

    var hasQualifying = false;
    var giftsInCart = false;
    if (lastCart) {
      lastCart.items.forEach(function (item) {
        if (qualifies(item)) hasQualifying = true;
        if (isGift(item)) giftsInCart = true;
      });
    }

    nodes.forEach(function (node) {
      var ctx = node.dataset.mwContext || 'product';
      var pid = parseInt(node.dataset.mwProductId, 10);
      var isExcludedPdp = ctx === 'product' && CFG.excludedProductIds.indexOf(pid) !== -1;

      var state, note, pill;

      if (isExcludedPdp) {
        state = 'info';
        note = CFG.text.noteExcluded;
        pill = null;
      } else if (ctx === 'cart') {
        if (hasQualifying && giftsInCart) {
          state = 'active'; note = CFG.text.noteCartActive; pill = CFG.text.pillInCart;
        } else {
          state = 'locked'; note = CFG.text.noteCartLocked; pill = CFG.text.pillLocked;
        }
      } else {
        state = giftsInCart && hasQualifying ? 'active' : 'ready';
        note = CFG.text.notePdp;
        pill = state === 'active' ? CFG.text.pillInCart : CFG.text.pillUnlocked;
      }

      var html = '<div class="mw-gifts__card mw-is-' + state + '">';
      html += '<div class="mw-gifts__head">';
      html += '<span class="mw-gifts__eyebrow">' + giftIcon() + esc(CFG.text.eyebrow) + '</span>';
      if (pill) {
        html += '<span class="mw-gifts__pill">' + (state === 'active' ? checkIcon() : '') + esc(pill) + '</span>';
      }
      html += '</div>';

      html += '<ul class="mw-gifts__list">';
      CFG.gifts.forEach(function (gift) { html += giftRow(gift, state); });
      html += '</ul>';

      html += '<div class="mw-gifts__foot">';
      html += '<span class="mw-gifts__value">' + esc(CFG.totalValue) + ' ' + esc(CFG.text.valueSuffix) + '</span>';
      html += '</div>';
      html += '<p class="mw-gifts__note">' + esc(note) + '</p>';
      html += '</div>';

      node.innerHTML = html;
    });
  }

  /* ---------- wiring ---------- */

  document.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-mw-swatch]');
    if (!sw) return;
    e.preventDefault();
    swapGiftVariant(parseInt(sw.dataset.mwProduct, 10), parseInt(sw.dataset.mwVariant, 10));
  });

  // Watch every cart mutation the theme performs.
  var nativeFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (typeof url !== 'string' && url && url.url) url = url.url;
    var isCartWrite = typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
    var wasInternal = internal;

    return nativeFetch.apply(this, arguments).then(function (response) {
      if (isCartWrite && !wasInternal) {
        setTimeout(function () { reconcile(); }, 60);
      }
      return response;
    });
  };

  function boot() {
    getCart().then(function (c) {
      lastCart = c;
      render();
      markGiftLineItems();
      reconcile();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-render the module whenever the theme swaps cart markup.
  var observerTarget = document.body;
  if (observerTarget) {
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var n = mutations[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches && n.matches('[data-mw-gifts]') ||
              n.querySelector && n.querySelector('[data-mw-gifts]'))) {
            render();
            markGiftLineItems();
            return;
          }
        }
      }
    });
    mo.observe(observerTarget, { childList: true, subtree: true });
  }
})();
